import { CommonModule, DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit, Renderer2 } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';

@Component({
  selector: 'app-antenatal-interventions',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './antenatal-interventions.component.html',
  styleUrl: './antenatal-interventions.component.scss'
})
export class AntenatalInterventionsComponent implements OnInit {

  constructor(
    private route: Router,
    private routes: ActivatedRoute,
    private metaService: Meta,
    private titleService: Title, private renderer: Renderer2,
    @Inject(DOCUMENT) private document: Document
  ) { }

  ngOnInit(): void {
    const homeSchema = {
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      "name": "NCare IVF Kannur, Kerala",
      "image": "https://ncareivfkannur.com/assets/images/header/logo.svg",
      "@id": "https://ncareivfkannur.com/",
      "url": "https://ncareivfkannur.com/antenatal-interventions",
      "telephone": "8606443030",
      "priceRange": "₹",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "Balram Memorial Buidling, N.E, Rajiv Gandhi Rd",
        "addressLocality": "Kannur, Kerala",
        "postalCode": "670001",
        "addressCountry": "IN"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": 11.8710259,
        "longitude": 75.3641411
      },
      "sameAs": [
        "https://www.facebook.com/people/Ncare-IVF-Kannur/61574105283962/",
        "https://www.instagram.com/ncareivfkannur/",
        "https://www.youtube.com/@NCAREIVFKANNUR/"
      ]
    }

    const script = this.renderer.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(homeSchema);
    this.renderer.appendChild(this.document.head, script);


    this.titleService.setTitle('Antenatal Interventions | High-Risk Pregnancy Care');
    this.metaService.updateTag({
      name: 'description',
      content: 'Get specialized antenatal interventions at NCARE IVF Centre in Kannur. Our expert team provides timely care and treatments for high-risk pregnancies to ensure maternal and fetal health.'
    });

    this.metaService.updateTag({
      name: 'keywords',
      content: 'Antenatal care, Antenatal Interventions, antenatal care center'
    });

    this.metaService.updateTag({
      property: 'og:title',
      content: 'Antenatal Interventions | High-Risk Pregnancy Care'
    });

    this.metaService.updateTag({
      property: 'og:description',
      content: 'Get specialized antenatal interventions at NCARE IVF Centre in Kannur. Our expert team provides timely care and treatments for high-risk pregnancies to ensure maternal and fetal health.'
    });

  }
  contactus() {
    this.route.navigate(['/contact-us']);
  }
}




